module.exports = __webpack_public_path__ + "static/img/code4.35f939a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer/code4.png
// module id = Kj0a
// module chunks = 35